"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChapterPublishState = void 0;
var ChapterPublishState;
(function (ChapterPublishState) {
    ChapterPublishState["NotPublished"] = "NotPublished";
    ChapterPublishState["WillPublish"] = "WillPublish";
    ChapterPublishState["Published"] = "Published";
})(ChapterPublishState = exports.ChapterPublishState || (exports.ChapterPublishState = {}));
